<template>
  <div class="loading-global">
    <div class="loading-global__logo">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill-rule="evenodd"
        stroke-linejoin="round"
        stroke-miterlimit="1.414"
        class="loading-global__logo-svg"
        clip-rule="evenodd"
        viewBox="0 0 9450 3413"
      >
        <!-- eslint-disable max-len -->
        <path
          d="M2968.94 1319.474h574.259v123.391h-438.685v210.427h389.085v123.391h-389.085v313.987H2968.94Zm852.395-5.508h125.653l339.485 776.704h-143.289l-78.258-186.189H3700.09l-79.36 186.189h-138.88Zm193.991 470.429-133.369-308.478-132.267 308.478Zm350.554-464.921h343.894c96.996 0 173.049 28.645 222.649 77.12 40.782 41.865 63.929 99.153 63.929 166.358v2.203c0 126.697-76.053 202.714-184.071 233.562l208.32 291.953h-159.822l-189.583-268.817h-169.742v268.817H4365.88Zm333.974 382.293c96.996 0 158.72-50.679 158.72-128.9v-2.203c0-82.628-59.52-127.799-159.822-127.799h-197.298v258.902Zm418.026-382.293h144.392l234.773 364.666 234.774-364.666h144.391v771.196h-135.573v-553.058l-243.592 363.564h-4.409l-241.386-361.36v550.854h-133.37Zm892.41 0h287.68c242.489 0 410.027 166.358 410.027 383.395v2.203c0 217.037-167.538 385.598-410.027 385.598h-287.68Zm287.68 647.805c162.027 0 267.84-109.069 267.84-260.004v-2.203c0-150.934-105.813-262.207-267.84-262.207h-152.107v524.414Zm493.108-262.754v-2.203c0-217.037 167.538-398.819 404.516-398.819s402.312 179.579 402.312 396.615v2.204c0 217.036-167.538 398.818-404.516 398.818s-402.312-179.578-402.312-396.615Zm664.641 0v-2.203c0-149.833-109.12-274.326-262.329-274.326s-260.125 122.29-260.125 272.122v2.204c0 149.832 109.12 274.325 262.329 274.325s260.125-122.289 260.125-272.122Zm224.191-385.051h135.574v387.801l367.04-387.801h166.436l-320.747 331.614 335.076 439.582h-164.231l-263.432-347.038-120.142 123.391v223.647H7679.91ZM1101.56 2243.38c-44.11-36.381-76.461-79.885-85.566-141.334-6.658-44.935.769-89.108 16.097-131.008 27.319-74.662 57.47-148.262 87.182-224.282 3.031 23.364 5.345 44.57 8.609 65.616 7.365 47.416 26.701 90.502 54.236 128.897 46.994 65.538 54.104 135.119 29.461 208.773v50.731h69.348c15.733-21.118 33.002-41.032 52.795-59.172 39.166-35.863 86.932-46.648 137.726-47.908 70.538-1.754 135.545-20.354 194.157-60.126.718-.491 6.429-5.962 9.878-6.53-46.479 70.282-94.83 145.155-141.83 212.178-29.834 42.53-68.618 76.513-119.102 93.89-62.121 21.366-122.086 9.016-181.151-13.17-6.722-2.52-13.211-5.702-21.073-9.143H1101.56Zm852.646-1142.8h357.562v1210.21h-632.609v-110.019h522.59v-990.17h-247.543Zm-121.594 599.65c-46.479 70.282-94.831 145.155-141.831 212.178-29.834 42.531-68.618 76.513-119.101 93.89-62.121 21.366-122.086 9.016-181.151-13.169-6.759-2.535-13.281-5.737-21.2-9.199 35.025-61.72 69.585-121.536 121.521-169.136 39.167-35.862 86.932-46.648 137.726-47.907 70.538-1.754 135.546-20.355 194.158-60.127.718-.491 6.428-5.962 9.878-6.53Zm-515.92 257.381c-72.423-45.41-130.813-96.277-143.57-182.372-6.657-44.935.769-89.108 16.098-131.008 27.319-74.662 57.469-148.262 87.182-224.282 3.03 23.364 5.344 44.57 8.609 65.617 7.364 47.416 26.7 90.501 54.235 128.896 48.362 67.446 54.484 139.173 27.231 215.215-15.064 42.071-32.374 83.396-49.785 127.934Zm680.346-579.737c-45.146 68.27-89.236 137.303-136.049 204.413-15.756 22.617-36.908 42.338-58.349 60.022-58.329 48.077-125.471 54.477-196.259 35.548-22.301-5.936-43.926-14.472-67.652-22.398 38.381-67.102 74.697-132.106 134.342-179.926 32.899-26.355 71.588-36.396 112.403-37.479 75.626-1.974 146.66-17.955 211.564-60.18Zm-510.004 249.569c-40.278-24.035-73.218-49.408-99.869-82.343-54.498-67.421-56.218-143.39-30.436-220.775 21.819-65.535 49.657-129.046 74.74-193.507 4.758-12.23 9.009-24.665 16.074-37.202 1.06 11.979 2.012 23.954 3.181 35.909 5.919 61.749 31.483 115.757 65.39 166.538 29.286 43.827 43.887 91.414 34.568 144.311-3.671 20.75-7.81 41.756-14.883 61.508-14.887 41.59-31.856 82.385-48.765 125.561Zm-165.436-416.844h-110.019v220.038H1101.56V1100.58h220.038Zm554.821-302.552c-3.406 98.296 2.751 193.267-19.844 286.372-19.28 79.478-68.223 133.388-143.091 164.006-26.716 10.926-54.613 18.951-81.738 28.215-54.859-122.753-49.843-222.431 36.272-306.238 49.829-48.504 106.496-90.038 160.253-134.501 14.619-12.113 29.838-23.504 48.148-37.854Z"
        />
        <!-- eslint-enable max-len -->
      </svg>
    </div>
    <div class="loading-global__spinner">
      <FontAwesomeIcon :icon="['fad', 'spinner-third']" class="loading-global__spinner-icon" size="2x" spin />
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

library.add(faSpinnerThird);

export default {
  name: 'LoadingGlobal',
};
</script>

<style scoped>
.loading-global {
  margin: auto;
}

.loading-global__logo {
  display: flex;
}

.loading-global__logo-svg {
  width: min(50vw, calc(50 * var(--vh, 1vh)));
  max-width: 350px;
  height: auto;
}

.loading-global__logo-svg path {
  fill: var(--medium);
}

.loading-global__spinner {
  display: flex;
}

.loading-global__spinner-icon {
  margin: auto;
  color: var(--medium);
}
</style>
